import Vue from 'vue';

/**
 * 纷享号埋点集合
 */


// 因为$buryPoint是挂在prototype上的，不是静态方法
const vm = new Vue();

// 打赏埋点
export function rewardApiBuryPoint(option) {
    vm.$buryPoint({
        actionType: 'gift',
        business_type: 'knowledge-operation',
        sceneType: 'knowledge-operation',
        id: option.rewardAccountId
    });
}

// 点赞埋点
export function praiseAndUninterestedApiBuryPoint(option) {
    vm.$buryPoint({
        actionType: option.buryPointPraised ? 'like' : 'unlike',
        business_type: 'knowledge-operation',
        sceneType: 'knowledge-operation',
        id: option.businessId
    });
}

// 关注埋点
export function attentionAndCollectApiBuryPoint(option) {
    // 取消不需要埋点
    if (option.isAttention === 0 || option.isAttention === '0') {
        vm.$buryPoint({
            actionType: 'follow',
            business_type: 'knowledge-operation',
            sceneType: 'knowledge-operation',
            id: option.businessId
        });
    }
}

// 跳转埋点
export function viewBuryPoint(option) {
    vm.$buryPoint({
        actionType: 'view',
        business_type: 'knowledge-operation',
        sceneType: 'knowledge-operation',
        id: option.id
    });
}
